import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { fetchUserLoans } from '../../store/actions/loanAction'

import { Box, Table, TableRow, TableBody, TableCell,  TableHead, Fab, Button} from '@mui/material';
import { isEmpty } from 'lodash';
import { grey, amber, red } from '@mui/material/colors';
import TableWithFilters from '../common/TableWithFilters';
import TitleWithEndAction from '../common/TitleWithEndAction';
import { AddRounded, PanoramaSharp } from '@mui/icons-material';
import EquipDemandsForm from './EquipementDemands/EquipDemandsForm';
import SwipeableTabs from '../../container/MUI/SwipeableTabs';
import EquipDemandList from './EquipementDemands/EquipDemandList';


class EmployeeEquipementList extends Component {
    state = { 
        selected: {},
        openFilters: false,
        changeLoan: {},
        changeDemand: ""
    }
    componentDidMount = async() => {
        // TO DO
        // FETCH USER LOAN LIST !OVER
        //
        // let list = await this.props.fetchUserLoans()
        // console.log('================EMPLOYEE EQUIPEMENT====================');
        // console.log({list});
        // console.log('====================================');
        if(isEmpty(this.props.LOANS)){
            await this.props.fetchUserLoans()
        }
    }
    getFinishedLoanList = () => {

    }

    // getRowStyle = (params) => {
    //     const value = params.getValue(params.id, 'is_over');
    //     console.log('====================================');
    //     console.log({value});
    //     console.log('====================================');
    //     if (value === false) {
    //       return { backgroundColor: amber[50] };
    //     }
    //     if (value === true) {
    //       return { backgroundColor: grey[50] };
    //     }
    //     return {};
    // };
    getRowStyle = (params) => {
        const over = params.is_over
        // console.log('====================================');
        // console.log({over, params});
        // console.log('====================================');
        if (params.loan_status.startsWith("RESA")) {
            return 'equip-resa';
        } else if (!over && new Date() > new Date(params.loan_estimated_return)) {
            return 'equip-late';
        } else if (!over ) {
            return 'equip-loan';
        }
        // if (over) {
        //     return 'equip-loan';
        // }
        
        return '';
    };

    render() {
        const { LOANS } = this.props;
        // console.log('===============PROPS FROM HOME PAGE EMPLOYEE=====================');
        // console.log(this.props);
        // console.log(this.props.notif);
        // console.log('====================================');
        return (
            <Box>
                {this.state.openForm &&
                    <EquipDemandsForm
                        {...this.props}
                        handleClose={() => this.setState({ openForm: false })}
                    />
                }
               
                <TitleWithEndAction
                    title={" "}
                >
                    <Fab 
                        color={"secondary"} 
                        onClick={() => this.setState({ openForm: true })} 
                        title="Nouvelle demande"
                        size="small"
                    >
                        <AddRounded />
                    </Fab>
                </TitleWithEndAction>
                <SwipeableTabs
                    labels={["Demandes","Emprunts","Réservations"]}
                >
                    <Box p={1}>
                        <EquipDemandList
                            {...this.props}
                        />
                    </Box>
                    <Box p={1}>
                        { !isEmpty(LOANS) && 
                            <TableWithFilters
                                internalId="loan_id"
                                rows={Object.values(LOANS).filter(row => !row.loan_status.startsWith("RESA"))}
                                getRowStyle={this.getRowStyle}
                                columns={[
                                    {
                                        field: 'loan_start_date',
                                        headerName: "Date Emprunt", 
                                        // valueGetter: (params) => `${new Date(params.row.loan_start_date).toLocaleDateString("fr-FR")}`,
                                        renderCell: (params) => (
                                            <span>{
                                                new Date(params.row.loan_start_date).getFullYear() > 1 ? 
                                                `${new Date(params.row.loan_start_date).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>

                                        ),
                                        width: 120
                                    },
                                    {
                                        field: 'loan_estimated_return',
                                        headerName: "Retour Prévu", 
                                        // valueGetter: (params) => `${new Date(params.row.loan_estimated_return).toLocaleDateString("fr-FR")}`,
                                        renderCell: (params) => (
                                            <span
                                                style={(new Date() > new Date(params.row.loan_estimated_return) && !params.row.is_over) ? { fontWeight: "bolder", color: "darkred"} : null}
                                            >{
                                                new Date(params.row.loan_estimated_return).getFullYear() > 1 ? 
                                                `${new Date(params.row.loan_estimated_return).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>

                                        ),
                                        width: 120
                                    },
                                    { field: 'equipement_ref', headerName: 'Référence', width: 160 },
                                    {
                                        field: 'equipement_name',
                                        headerName: 'Intitulé', 
                                        width: 350,
                                        renderCell: (params) => (
                                            <span className="a-like" >{params.row.equipement_name}</span>
                                        ),
                                    },
                                    {
                                        field: 'equipement_brand',
                                        headerName: 'Marque', 
                                        width: 200,
                                        renderCell: (params) => (
                                            <span className="a-like" >{params.row.equipement_brand}</span>
                                        ),
                                    },
                                    // {
                                    //     field: 'loan_status',
                                    //     headerName: 'Statut', 
                                    //     width: 100,
                                    //     sortable: true,
                                    //     valueGetter: (params) => `${params.row.loan_status}`,
                                    // },
                                    
                                ]}
                            />
                        }     
                    </Box>
                    <Box p={1}>
                        { !isEmpty(LOANS) && 
                            <TableWithFilters
                                internalId="loan_id"
                                rows={Object.values(LOANS).filter(row => (row.loan_status.startsWith("RESA") && row.loan_status != "RESA_CANCELED"))}
                                getRowStyle={this.getRowStyle}
                                columns={[
                                    {
                                        field: 'loan_start_date',
                                        headerName: "Date Emprunt", 
                                        // valueGetter: (params) => `${new Date(params.row.loan_start_date).toLocaleDateString("fr-FR")}`,
                                        renderCell: (params) => (
                                            <span>{
                                                new Date(params.row.loan_start_date).getFullYear() > 1 ? 
                                                `${new Date(params.row.loan_start_date).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>

                                        ),
                                        width: 120
                                    },
                                    {
                                        field: 'loan_estimated_return',
                                        headerName: "Retour Prévu", 
                                        // valueGetter: (params) => `${new Date(params.row.loan_estimated_return).toLocaleDateString("fr-FR")}`,
                                        renderCell: (params) => (
                                            <span
                                                style={(new Date() > new Date(params.row.loan_estimated_return) && !params.row.is_over) ? { fontWeight: "bolder", color: "darkred"} : null}
                                            >{
                                                new Date(params.row.loan_estimated_return).getFullYear() > 1 ? 
                                                `${new Date(params.row.loan_estimated_return).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>

                                        ),
                                        width: 120
                                    },
                                    // {
                                    //     field: 'loan_end_date',
                                    //     headerName: "Retour", 
                                    //     // valueGetter: (params) => `${new Date(params.row.loan_end_date).toLocaleDateString("fr-FR")}`,
                                    //     renderCell: (params) => (
                                    //         <span>{
                                    //             new Date(params.row.loan_end_date).getFullYear() > 1 ? 
                                    //             `${new Date(params.row.loan_end_date).toLocaleDateString("fr-FR")}` : 
                                    //             "--"
                                    //         }
                                    //         </span>

                                    //     ),
                                    //     width: 120
                                    // },
                                    { field: 'equipement_ref', headerName: 'Référence', width: 160 },
                                    {
                                        field: 'equipement_name',
                                        headerName: 'Intitulé', 
                                        width: 350,
                                        renderCell: (params) => (
                                            <span className="a-like" >{params.row.equipement_name}</span>
                                            // <span className="a-like" onClick={() => this.props.handleSingle(params.row.equipement)}>{params.row.equipement_name}</span>
                                        ),
                                    },
                                    {
                                        field: 'equipement_brand',
                                        headerName: 'Marque', 
                                        width: 200,
                                        renderCell: (params) => (
                                            <span className="a-like" >{params.row.equipement_brand}</span>
                                            // <span className="a-like" onClick={() => this.props.handleSingle(params.row.equipement)}>{params.row.equipement_brand}</span>
                                        ),
                                    },
                                    {
                                        field: 'loan_status',
                                        headerName: 'Statut', 
                                        width: 200,
                                        sortable: true,
                                        valueGetter: (params) => `${params.row.loan_status}`,
                                    },                                        
                                ]}
                            />
                        } 
                    </Box>
                </SwipeableTabs>
            </Box>                
        );
    }
}
export default EmployeeEquipementList;

// function mapStateToProps(state){
//     return {
//         LOANS: state.loans.USER,
//     }
// }

// function mapDispatchToProps(dispatch){
//     return bindActionCreators({
//         fetchUserLoans,
//     }, dispatch)
// }

// export default connect(mapStateToProps, mapDispatchToProps)(EmployeeEquipementList);